import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { SigninSignupComponent } from './signin-signup/signin-signup/signin-signup.component';
import { RestPasswordComponent } from './signin-signup/rest-password/rest-password.component';
import { ForgotPasswordComponent } from './signin-signup/forgot-password/forgot-password.component';
import { ChangePasswordComponent } from './signin-signup/change-password/change-password.component';
import { ConstantMaterialModule } from './material_module/constant-material.module';
import { PreviewComponent } from './preview/preview.component';
import { LazyImgDirective } from './lazy-img-directive.directive';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { LottieModule } from "ngx-lottie";
import player from "lottie-web";
import { V3TemplatesComponent } from './v3-templates/v3-templates.component';
import { V3PageSelectionPopupComponent } from './v3-page-selection-popup/v3-page-selection-popup.component';
import { ListProductsComponent } from './products/list-products/list-products.component';

import { CreateProductComponent } from './products/create-product/create-product.component';
import { CreateCategoryComponent } from './products/create-category/create-category.component';
import { CreateCollectionComponent } from './products/create-collection/create-collection.component';
import { DeleteProductComponent } from './products/delete-product/delete-product.component';
import { DeleteCategoryComponent } from './products/delete-category/delete-category.component';
import { SearchProductComponent } from './products/search-product/search-product.component';
// import { LottieLoaderComponent } from './shared-module-files/components/lottie-loader/lottie-loader.component';
// import { LottiePoppperComponent } from './shared-module-files/components/lottie-poppper/lottie-poppper.component';
import { QuillModule } from 'ngx-quill';
import { CommonComponentModule } from './master_modules/masters/apps/common-component/common-component.module';
import {
  API_URL, ECOMMERCE_URL, CMIS_URL, BUCKET_URL, PASSBOOK_URL, APPOINTMENT_URL,
  // RECOMMENDATION_URL
} from 'simpo-component-library';
import { environment } from 'src/environments/environment';
import { NgxPaginationModule } from 'ngx-pagination';
import { DeleteCollectionsComponent } from './products/delete-collections/delete-collections.component';
import { PreviewCurrentFileComponent } from './preview-current-file/preview-current-file.component';
import { ListIntegrationsComponent } from './integrations/list-integrations/list-integrations.component';
import { MatDividerModule } from '@angular/material/divider';
import { StatisticsComponent } from './integrations/statistics/statistics.component';

import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { ConfigureFacebookPagesComponent } from './integrations/configure-facebook-pages/configure-facebook-pages.component';
import { ConfigureWhatsappBusinessComponent } from './integrations/configure-whatsapp-business/configure-whatsapp-business.component';
import { ConfigureGoogleCalendarComponent } from './integrations/configure-google-calendar/configure-google-calendar.component';
import { ConfigureZoomMeetingsComponent } from './integrations/configure-zoom-meetings/configure-zoom-meetings.component';


import { InfiniteScrollModule } from 'ngx-infinite-scroll';



// Note we need a separate function as it's required
// by the AOT compiler.
export function playerFactory() {
  return player;
}
// import { SimpleTestimonialCardV2Component } from './master_modules/masters/apps/elements/testimonial_cards/simple-testimonial-card-v2/simple-testimonial-card-v2.component';
// import { BannerContentMiddleComponent } from './master_modules/masters/apps/elements/banner-content-middle/banner-content-middle.component';
// import { NollieOurTeamComponent } from './master_modules/masters/apps/screening_components/our-team/nollie-our-team/nollie-our-team.component';
// import { NollieFooterComponent } from './master_modules/masters/apps/screening_components/footers/nollie-footer/nollie-footer.component';
// import { TextCardComponent } from './master_modules/masters/apps/elements/text-card/text-card.component';
// import { V2OurValuesComponent } from './master_modules/masters/apps/screening_components/our-values/v2-our-values/v2-our-values.component';

@NgModule({
  declarations: [
    AppComponent,
    SigninSignupComponent,
    RestPasswordComponent,
    ForgotPasswordComponent,
    ChangePasswordComponent,
    PreviewComponent,
    LazyImgDirective,
    V3TemplatesComponent,
    V3PageSelectionPopupComponent,
    ListProductsComponent,
    CreateProductComponent,
    CreateCategoryComponent,
    CreateCollectionComponent,
    DeleteProductComponent,
    DeleteCategoryComponent,
    SearchProductComponent,
    DeleteCollectionsComponent,
    // PreviewCurrentFileComponent,
    ListIntegrationsComponent,
    StatisticsComponent,
    ConfigureFacebookPagesComponent,
    ConfigureWhatsappBusinessComponent,
    ConfigureGoogleCalendarComponent,
    ConfigureZoomMeetingsComponent,





    // LottieLoaderComponent,
    // LottiePoppperComponent

    // SimpleTestimonialCardV2Component,
    // BannerContentMiddleComponent,
    // NollieOurTeamComponent,
    // NollieFooterComponent,
    // TextCardComponent,
    // V2OurValuesComponent,



    // NollieHerobannerComponent
    // MainLandingBusinessComponent,
    // SidnavMasterComponent,
    // SecondSideNavMasterComponent
  ],
  imports: [

    QuillModule.forRoot(
      {
        modules: {
          syntax: true,
          toolbar: {
            container: [
              ['bold', 'italic', 'underline', 'strike'],
              ['code-block'],
              [{ 'list': 'ordered' }, { 'list': 'bullet' }],
              ['link'],
              [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
              ['link', 'image', 'video']
            ],
          },
          keyboard: {
            bindings: {
              enter: {
                key: 13,
                handler: (range: any, context: any) => {
                  return true;
                }
              }
            }
          }
        }
      }
    ),
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    ConstantMaterialModule,
    HttpClientModule,
    NgxPaginationModule,
    NgMultiSelectDropDownModule.forRoot(),
    LottieModule.forRoot({ player: playerFactory }),
    CommonComponentModule,
    MatDividerModule,
    MatDialogModule,
    MatButtonModule,
    MatIconModule,
    InfiniteScrollModule

  ],
  providers: [
    { provide: API_URL, useValue: environment.baseUrl },
    { provide: ECOMMERCE_URL, useValue: environment.ecommerceWithoutGateway },
    { provide: CMIS_URL, useValue: environment.baseUrl },
    { provide: PASSBOOK_URL, useValue: environment.passbookBaseUrl },
    { provide: BUCKET_URL, useValue: { bucketDetails: environment.componentImageUploading.S3TransferUtility.Default, poolId: environment.componentImageUploading.CredentialsProvider.CognitoIdentity.Default.PoolId } },
    { provide: APPOINTMENT_URL, useValue: environment.appointementUrl },
    // { provide: RECOMMENDATION_URL, useValue: environment.recommendationUrl }
  ],
  bootstrap: [AppComponent],
})
export class AppModule { }
